(function () {
  const iconSel = '.ixpDAKndL0vFZKJkb.icon-search';
  const openerSel = 'a.snize-sticky-searchbox.snize-custom-widget-opener';
  const modalId = 'snize-modal-sticky-searchbox';
  const COOLDOWN_MS = 700;

  let cooldownUntil = 0;

  function modalOpen() {
    const m = document.getElementById(modalId);
    if (!m) return false;
    return m.style.display === 'block' || getComputedStyle(m).display === 'block';
  }

  function getBtn() {
    return document.querySelector('.snize-close-fixed');
  }

  function hideBtn() {
    const b = getBtn();
    if (b) b.style.display = 'none';
  }

  function showBtn() {
    const b = getBtn();
    if (b) b.style.display = 'flex';
  }

  function syncBtn() {
    if (Date.now() < cooldownUntil) {
      hideBtn();
      return;
    }
    modalOpen() ? showBtn() : hideBtn();
  }

  function openSnize() {
    cooldownUntil = 0;
    const opener = document.querySelector(openerSel);
    if (opener) opener.click();
    syncBtn();
    requestAnimationFrame(syncBtn);
    setTimeout(syncBtn, 50);
  }

  function closeSnize() {
    cooldownUntil = Date.now() + COOLDOWN_MS;
    hideBtn();

    const modal = document.getElementById(modalId);
    if (!modal) return;

    const nativeClose = modal.querySelector('button.snize-close-button');
    if (nativeClose) nativeClose.click();
    else modal.style.display = 'none';

    setTimeout(syncBtn, COOLDOWN_MS);
  }

  function addCloseBtnOnce() {
    if (getBtn()) return;

    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'snize-close-fixed';
    b.setAttribute('aria-label', 'Close search');
    b.innerHTML = '&times;';
    b.style.display = 'none';

    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeSnize();
    });

    document.body.appendChild(b);
  }

  function init() {
    addCloseBtnOnce();
    syncBtn();

    document.addEventListener('click', function (e) {
      if (!e.target.closest(iconSel)) return;
      e.preventDefault();
      e.stopPropagation();
      openSnize();
    }, true);

    document.addEventListener('click', function (e) {
      if (e.target.closest('button.snize-close-button') || e.target.closest('.snize-search-close')) {
        cooldownUntil = Date.now() + COOLDOWN_MS;
        hideBtn();
        setTimeout(syncBtn, COOLDOWN_MS);
      }
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modalOpen()) closeSnize();
    });

    setInterval(syncBtn, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();



